import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { CommonService } from '../../services/common.service';
import { AlertService} from '../../services/alert.service';
import { NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { PassengersReportService } from '../../services/passengers-report.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable} from 'rxjs/Observable';
import {any} from "codelyzer/util/function";
import swal from 'sweetalert2';
import { VehiclesServiceService } from '../../services/vehicles-service.service'

@Component({
  selector: 'app-transmission-vehicles',
  templateUrl: './transmission-vehicles.component.html',
  styleUrls: ['./transmission-vehicles.component.css']
})
export class TransmissionVehiclesComponent implements OnInit {
  modalVehicle: any;
  imeiVei: any= {};
  plates: any = [];
  platesBuffer = [];
  bufferSize = 50;
  user_account: any;
  vehicleSave: any= {};
  vehicles: any;

  plate:any;


  @ViewChild('modalAddVehicle') modalAddVehicle: HTMLElement;
  constructor(
    private commonService: CommonService,
    private alertService: AlertService,
    private modalService: NgbModal,
    private vpcReportService: PassengersReportService,
    private spinner: NgxSpinnerService,
    private vehiclesServiceService : VehiclesServiceService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit() {
    this.getPlates();
    this.getVehiclesTransmission();
  }

  getPlates(): void {
    this.spinner.show();
    this.vpcReportService.getPlates(this.commonService.getUserName()).then(response => {
      this.plates = response;
      console.log('response : : : ', this.plates)
      this.platesBuffer = this.plates.slice(0, this.bufferSize);
      this.user_account = this.commonService.getUserName();
      this.imeiVei   = this.plates.sn_imei_id;
    });
    this.spinner.hide();
  }

  openModalVehicle(): void {
    console.log('ingresando al modal ')
    let that = this;
    this.modalVehicle = this.modalService.open(this.modalAddVehicle, {size: 'lg'});
    this.modalVehicle.result.then(value => {
      console.log('component.abrirDialogovehiculo.modalRef.result.then', value);

    }).catch(reason => {
      console.log('component.abrirDialogovehiculo.modalRef.result.catch', reason);
    });
  }

  getVehiclesTransmission(): void {
    console.log('this.user_account en get veh : ', this.commonService.getUserName())
      this.vehiclesServiceService.getVehiclesTransmission(this.commonService.getUserName()).then(response => {
        this.vehicles = response
        console.log('response in component : ', response[0].plate);
    });
  }
  removeVh(id): void{
    let that = this;
    console.log('i i i i i i : ', id)
    swal({
      title: '¿Esta seguro de eliminar el vehiculo para la transmision en linea?',
      text: '',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí',
      cancelButtonText: 'No'
    }).then(function (s) {
      if(s.dismiss !== undefined) {
        if (s.dismiss.toString() === 'cancel') {
        }
      }else {
        console.log('Eliminar placa');
        that.vehiclesServiceService.deleteVehiclesTrans(id)
          .then(obj => {
            const response = JSON.parse(obj.toString());
            console.log('response   response   responseresponse  responseresponseresponse vvv : ', response[0])
            if (response.status === 'EXITO') {
              that.getVehiclesTransmission();
              that.router.navigate(['/home/transmissionVehicles']);
              swal({
                title: response.message,
                text: '',
                type: 'success',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#ff5370',
                confirmButtonText: 'Volver',
                // cancelButtonText: 'No'
              }).catch(swal.noop);
            } else {
              swal({
                title: response.message,
                text: '',
                type: 'error',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#ff5370',
                confirmButtonText: 'Volver',
                // cancelButtonText: 'No'
              }).catch(swal.noop);
            }
        });
      }
    });
  }

  addVehicle(): void {
    let that = this;
    console.log('imeiVei :', this.imeiVei)
    if(this.imeiVei) {
      this.vehicleSave.User_account = this.commonService.getUserName();
      this.vehicleSave.Imei = this.imeiVei.sn_imei_id
      this.vehicleSave.Plate = this.imeiVei.tracker_name
      swal({
        title: '¿Esta seguro de adicionar el vehículo a la transmisión en linea?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí',
        cancelButtonText: 'No'
      }).then(function (s) {
        if(s.dismiss !== undefined) {
          if (s.dismiss.toString() === 'cancel') {
          }
        }else {
          that.vehiclesServiceService.saveVehiclesTransmission(that.vehicleSave)
            .then(obj => {
              const response = JSON.parse(obj.toString());
              if (response.status === 'EXITO') {
                that.getVehiclesTransmission();
                that.router.navigate(['/home/transmissionVehicles']);
                swal({
                  title: response.message,
                  text: '',
                  type: 'success',
                  showCancelButton: false,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#ff5370',
                  confirmButtonText: 'Volver',
                  // cancelButtonText: 'No'
                }).catch(swal.noop);
              } else {
                swal({
                  title: response.message,
                  text: '',
                  type: 'error',
                  showCancelButton: false,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#ff5370',
                  confirmButtonText: 'Volver',
                  // cancelButtonText: 'No'
                }).catch(swal.noop);
              }
          });
        }
      });
    }else {
      swal({
        title: 'Debe seleccionar una placa.',
        text: '',
        type: 'warning'
      }).catch(swal.noop);
    }
  }
}



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/components/transmission-vehicles/transmission-vehicles.component.ts